import { IGetOccupierPropertiesDto } from '@/bundles/Contact/dto';
import { Nullable } from '@/utils/types';
import { IPaginationResponse } from '@/bundles/App/interfaces/IPaginationResponse';
import { IMapPinBase, IMapPinResponseBase } from '@/bundles/Map/types';
import { MapPinBase } from '@/bundles/Map/models/MapPinBase';
import { AppService } from '@/bundles/App/models/AppService';
import { IContactPropertyMapPinResponse } from '@/bundles/Contacts/types';
import { ContactPropertyMapPin } from '@/bundles/Contacts/models/ContactPropertyMapPin';

export default class ContactServiceLegacy extends AppService {
  async getContactForMember (id: number, legacy_id?: Nullable<string>, options = {}): Promise<any> {
    try {
      return await this.transport.get(`/contact/member/${ id }${legacy_id ? `?legacy_id=${ legacy_id }` : ''}`, {}, null, { options });
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getAllMapPins (
    filterParams: Record<string, unknown> = {},
    controller?: AbortController,
  ): Promise<IMapPinBase[]> {
    try {
      const { result } = await this.transport.post('/contact/list/coordinates', filterParams, controller ?? null);

      const rows = result as Array<IMapPinResponseBase | IContactPropertyMapPinResponse>;
      // with "Property by Property Location" a contact has a row per property; its pins share the contact's number
      const contactNumbers = new Map<string, number>();
      rows.forEach((row) => {
        if (!contactNumbers.has(row._key)) {
          contactNumbers.set(row._key, contactNumbers.size + 1);
        }
      });

      return rows.map((row) => {
        const number = contactNumbers.get(row._key) as number;

        return 'property_key' in row ? new ContactPropertyMapPin(row, number) : new MapPinBase(row, number);
      });
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }

  async getOccupierProperties (
    id: string,
    params: IGetOccupierPropertiesDto,
    controller?: AbortController,
  ): Promise<IPaginationResponse<Record<string, unknown>>> {
    try {
      const response = await this.transport.get(`/contact/${ id }/occupier-properties`, params, controller ?? null);

      return {
        data: response.result,
        total: response.total ?? 0,
      };
    } catch (error) {
      throw this.errorMapper.mapToCodeModel(error);
    }
  }
}
